import { GrowthBook } from '@growthbook/growthbook-react'

// Fail-open by design: if init/fetch fails, growthbook-react's hooks fall back
// to each call site's own default value — never throw, never block render.
export const growthbook = new GrowthBook({
  apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
  clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: import.meta.env.MODE !== 'production',
  subscribeToChanges: true,
})

export function loadGrowthbookFeatures() {
  if (!import.meta.env.VITE_GROWTHBOOK_API_HOST || !import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY) {
    return Promise.resolve()
  }
  return growthbook.loadFeatures({ timeout: 4000 }).catch(() => {
    // Fail-open: no features loaded -> every useFeatureValue() call resolves to its default.
  })
}

// Tenant-targeted flags (e.g. tags-enabled) match on tenant_slug. Merge rather
// than replace so the identity attributes set at login (id, orgId) survive.
export function setTenantSlugAttribute(tenantSlug) {
  growthbook.setAttributes({ ...growthbook.getAttributes(), tenant_slug: tenantSlug ?? null })
}
